import { render } from "./AppSlider.vue?vue&type=template&id=48fc7e64&scoped=true"
import script from "./AppSlider.vue?vue&type=script&lang=js"
export * from "./AppSlider.vue?vue&type=script&lang=js"

import "./AppSlider.vue?vue&type=style&index=0&id=48fc7e64&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fc7e64"]])

export default __exports__